/** @jsx jsx */
import React from "react"
import { jsx } from "@emotion/core"
import PropTypes from "prop-types"
import { searchBarContainerStyles } from "./styles"
import { AutoComplete } from "antd"

import "react-intl-tel-input/dist/main.css"

const SearchBarComponent = (props, ref) => {
  const { iconStyle, error, customStyles, ...rest } = props
  return (
    <div className="atom-search-bar-container" css={searchBarContainerStyles}>
      <AutoComplete
        dropdownStyle={{ backgroundColor: "#0F0D2B", width: "100%" }}
        ref={ref}
        {...rest}
      ></AutoComplete>
      {error && <span className="error-text">{error}</span>}
    </div>
  )
}
export const SearchBar = React.forwardRef(SearchBarComponent)
SearchBar.propTypes = {
  /** Apart from all standard input [props](https://ant.design/components/auto-complete/), this component accepts -  */
  /** error string, only to be passed if input is in error state. */
  error: PropTypes.string,
  placeholder: PropTypes.string,
}

SearchBar.defaultProps = {
  error: "",
  parentref: null,
}
